function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import ButtonIconBase from './ButtonIconBase';
import classNames from 'classnames';

function ButtonIcon(props) {
  var buttonClasses = classNames('btn-default', props.className);
  return /*#__PURE__*/React.createElement(ButtonIconBase, _extends({}, props, {
    className: buttonClasses
  }));
}

ButtonIcon.propTypes = _extends({}, ButtonIconBase.propTypes);
ButtonIcon.defaultProps = _extends({}, ButtonIconBase.defaultProps);
export default ButtonIcon;
//# sourceMappingURL=ButtonIcon.js.map